<template>
  <div
    id="feature"
    class="home-feature d-flex flex-column"
  >
    <div class="feature-descript">
      <h2>
        <div class="sup-label">
          平台優勢
        </div>
        <div
          id="feature-title"
          class="feature-title"
        >
          <span
            class="main-label"
          >
            Advantage
          </span>
          <span
            class="main-label"
            data-depth=".2"
          >
            Advantage
          </span>
        </div>
      </h2>
    </div>
    <div class="d-flex justify-content-center flex-wrap m-auto">
      <div class="feature-card">
        <div class="card-header">
          <div class="card-icon">
            <b-img
              :src="require('@/assets/images/icons/ad.png')"
              alt="廣告效果"
            />
          </div>
          <h3>
            廣告效果
          </h3>
        </div>
        <div class="card-body">
          <h4>
            有效的廣告投放策略
          </h4>
          <br>
          廣告能夠被準確地呈現給目標玩家群體。擁有廣告投放的專業團隊，能夠進行精確的定位和適當的廣告曝光，提高遊戲伺服器的曝光率和玩家吸引力。
        </div>
      </div>
      <div class="feature-card">
        <div class="card-header">
          <div class="card-icon">
            <b-img
              :src="require('@/assets/images/icons/ui.png')"
              alt="操作介面"
            />
          </div>
          <h3>
            操作介面
          </h3>
        </div>
        <div class="card-body">
          <h4>
            直觀的用戶介面
          </h4>
          <br>
          介面操作是業界首創最簡單方便的，讓您輕鬆設定您的私服遊戲推廣活動。玩家能夠輕鬆找到所需的功能和資訊。並提供導航和搜索功能，以便玩家快速找到所需的內容。
        </div>
      </div>
      <div class="feature-card flex-grow-1">
        <div class="card-header">
          <div class="card-icon">
            <b-img
              :src="require('@/assets/images/icons/data-list.png')"
              alt="詳細資訊"
            />
          </div>
          <h3>
            詳細資訊
          </h3>
        </div>
        <div class="card-body">
          <h4>
            詳細的伺服器資訊
          </h4>
          <br>
          遊戲模式、版本、人數上限、遊戲風格等，讓玩家能夠更好地選擇適合自己的伺服器。同時，定時分享最新的私服技巧、遊戲技巧。
        </div>
      </div>
      <div class="feature-card flex-grow-1">
        <div class="card-header">
          <div class="card-icon">
            <b-img
              :src="require('@/assets/images/icons/game.png')"
              alt="多種遊戲私服"
            />
          </div>
          <h3>
            遊戲私服種類
          </h3>
        </div>
        <div class="card-body">
          <h4>
            多樣的遊戲私服
          </h4>
          <br>
          提供多種遊戲私服。天堂私服、RO私服、楓之谷私服、墨香私服以及其他遊戲私服
        </div>
      </div>
      <div class="feature-card flex-grow-1">
        <div class="card-header">
          <div class="card-icon">
            <b-img
              :src="require('@/assets/images/icons/process.png')"
              alt="支援服務"
            />
          </div>
          <h3>
            支援服務
          </h3>
        </div>
        <div class="card-body">
          <h4>
            方便的支援服務
          </h4>
          <br>
          線上客服，提供全天候的論壇發布服務。方便您能夠及時推廣私服和獲得幫助。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BImg,
} from 'bootstrap-vue'
import Parallax from 'parallax-js'

export default {
  components: {
    BImg,
  },
  directives: {
    // Ripple,
  },
  data() {
    return {
    }
  },

  computed: {
  },

  mounted() {
    const { windowWidth } = this.$store.state.app
    if (windowWidth > 576) {
      const scene = document.getElementById('feature-title')
      // eslint-disable-next-line no-unused-vars
      const parallaxInstance = new Parallax(scene, {
        relativeInput: true,
      })
    }
  },

  methods: {
  },

  setup() {
  },
}
</script>
<style lang="scss" scoped>
.home-feature{
  position: relative;
  height: 100%;
  min-height: 750px;
  padding: 10vh 5vw 8vh;
  background-color: black;
}
.feature-descript {
  width: 100%;
  margin-bottom: 1rem;
  .sup-label{
    display: block;
    font-size: clamp(1rem, 2vw, 2.5rem);
    font-weight: 600;
    color: #fff;
    margin-bottom: 2rem;
  }
  .feature-title {
    position: relative;
  }
  .main-label {
    position: relative;
    display: block;
    line-height: 1;
    font-size: clamp(3rem, 9vw, 12rem);
    -webkit-text-stroke-width: 0.8px;
    -webkit-text-stroke-color: #fff;
    color: rgba(255, 255, 255, 0);
    text-transform: uppercase;
  }
  .main-label:nth-child(2) {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: block;
    line-height: 1;
    -webkit-text-stroke-width: 0px;
    text-shadow: #3f48cc 10px 0px 14px;
    text-transform: uppercase;
  }
}
.feature-card {
  // width: 600px;
  background-color: #ffffff;
  box-shadow: 0px 4px 4px rgba(233, 233, 233, 0.25);
  border-radius: 29px;
  width: 300px;
  max-width: 300px;
  min-height: 300px;
  margin: 20px;
  .card-icon {
    display: inline-block;
    margin-right: 2rem;
    padding: 12px;
    border: 2.75px #0011ff solid;
    border-radius: 50%;
    img {
      width: 64px;
    }
  }
  h3 {
    display: inline-block;
    font-weight: 800;
  }
  h4 {
    font-weight: 600;
  }
}
.feature-card:hover {
  box-shadow: 0 0 40px #0011ff;
}
</style>
<style lang="scss" scoped>
@media screen and (max-width: 992px) {
  .home-feature{
    min-height: 1200px;
  }
}

</style>
